const AnnouncementsQueryKeys = {
  global: ["announcements"] as const,
};

export { AnnouncementsQueryKeys };
